import React from 'react'
import { Flag } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'
import TaskStatus from '@SonarCX/components/molecules/RenderOptions/TaskStatus'
import Dropdown from '@SonarCX/components/atoms/Dropdown'

import { selectTaskPriority } from '@SonarCX/slices/priority'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'
import useCommonStyles from '../commonStyles'

const ChosenPriority = ({ selected }) => {
  if (!selected) {
    return <TaskStatus opt={{ name: 'Unassigned' }} testId='priority' />
  }

  return <TaskStatus opt={selected} testId='priority' />
}

const SetPriority: React.FC = () => {
  const { priorities } = useAppSelector(selectTaskPriority)

  const { selected, patchTasks } = useTaskMultiEdit()

  const [value, setValue] = React.useState(null)

  const current = React.useMemo(
    () => priorities.find(priority => priority.id === value),
    [priorities, value]
  )

  const classes = useCommonStyles()

  const handleClose = React.useCallback(() => {
    setValue(null)
  }, [])

  const handleAccept = React.useCallback(async () => {
    const updates: TaskPatch[] = selected.map(id => ({
      id,
      priority_id: value
    }))
    await patchTasks({ updates, message: 'Priority updated' })
    handleClose()
  }, [selected, value, patchTasks, handleClose])

  return (
    <CommonButton
      title='Set priority'
      Icon={Flag}
      onAccept={handleAccept}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <div className={classes.title}>Priority</div>

        <Dropdown
          options={priorities.map(({ id }) => id)}
          renderOption={id => {
            const opt = priorities.find(s => s.id === id)

            if (opt) {
              return <TaskStatus key={id} opt={opt} testId='priority' />
            }
            return null
          }}
          selected={value}
          onSelect={id => setValue(id)}
          hideAdd
        >
          <div className={classes.center}>
            <ChosenPriority selected={current} />
          </div>
        </Dropdown>
      </div>
    </CommonButton>
  )
}

export default SetPriority
